<h1 mat-dialog-title>
Error
</h1>
<div mat-dialog-content>
  <div class="error-wrapper">
    <ng-container *ngIf="data.IdRow || data.ColumnLetter || data.ColumnName; else onlyMessage">
      <div class="error-row" *ngIf="data.IdRow">
        <span class="error-label">Row:</span>
        <span class="error-value">{{ data.IdRow }}</span>
      </div>
      <div class="error-row" *ngIf="data.ColumnLetter">
        <span class="error-label">Column letter:</span>
        <span class="error-value">{{ data.ColumnLetter }}</span>
      </div>
      <div class="error-row" *ngIf="data.ColumnName">
        <span class="error-label">Header name:</span>
        <span class="error-value">({{ data.ColumnName }})</span>
      </div>
      <div class="error-row">
        <span class="error-label">Message:</span>
        <span class="error-value">{{ data.Message }}</span>
      </div>
    </ng-container>

    <ng-template #onlyMessage>
      <div class="error-row">
        <span class="error-label">Message:</span>
        <span class="error-value">{{ data.Message }}</span>
      </div>
    </ng-template>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true">OK</button>
</div>
